<template>
    <div class="page-layout blank contacts-manage">
        <div class="pb-10 pl-3 pr-3">
            <h2 class="ml-0 mb-0 mt-0">
                <div class="d-flex flex-wrap justify-content-between">
                    <!-- Breadcrumb Section -->
                    <div class="breadcrumbactive">
                        <div>
                            <span class="text-white">
                                <router-link to="/teams/TeamListView" style="color: #fff !important;text-decoration: none;padding-left: 4px;">List View</router-link>
                            </span>
                            <div v-if="mode == 'view'">View Team</div>
                            <div v-if="mode == 'edit'">Edit Team</div>
                        </div>
                    </div>
                    <div class="margin-mx-577">
                        <button v-if="activetab =='1' && createJson.created_by_id == loggedInUser.user_id" class="btn btn-new-danger btn-wide px-6 mr-4 mt-3 mar-top-zero" 
                        @click="deleteMember()" :style="selected_members_id.length ? '' : 'background-color: #ababab; border-color: #ababab'" 
                        :disabled="disableDeletebtn || members_list.length<2" style="position: relative;">
                            <img class="btn-icon" src="/static/images/delete-icon.png"/> Delete
                            <hollow-dots-spinner v-if="disableButtonAndDisplayLoader == true" style="position: absolute;margin: 0;top: 22px;display: flex;justify-content: center;width: 100% !important;" :animation-duration="1200" :dot-size="10" :dots-num="3" :color="'#00448b'" />
                        </button>
                        <button v-if="activetab =='1' && createJson.created_by_id == loggedInUser.user_id && userPermissions.teams.permitted_actions.create" class="btn btn-new-save btn-wide px-6 mt-3 mar-top-zero" @click="addMember()"><img class="btn-icon" src="/static/images/add-user.png" /> Add Member</button>
                        <button v-if="activetab !='1' && mode == 'view' && createJson.created_by_id == loggedInUser.user_id" class="btn btn-new-edit text-white"  @click="changeMode('edit')"><img src="/static/images/images-new-theme/icons/edit-white.png" width="15" style="margin-right: 8px;">Edit</button>
                    </div>
                </div>
            </h2>
            <div class="team-member-card">
                <div class="d-flex justify-content-between">
                    <div class="d-flex">
                        <!-- <div>
                            <p class="team-icon">DU</p>
                            <custom-upload-picture @uploadImage="uploadImage"></custom-upload-picture>
                        </div> -->
                        <div class="mr-2">
                            <span style="text-align:center; position:relative">
                            <hollow-dots-spinner v-if="img_loader" style="position: absolute;margin: 0;top: 55px;left:-5px;display: flex;width: 108% !important;" :animation-duration="1200" :dot-size="10" :dots-num="3" :color="'#00448b'" />
                            <img v-if="createJson.logo" :src="createJson.logo" class="contact-image mr-2" alt="Product Pic"
                                style="height: 50px; width: 50px; border-radius: 6px;border:1px solid #cdd2da;" />
                            <!-- <img v-else :src="imgDataUrl" class="contact-image" alt="Product Pic"
                                style="height: 6em; width: 6em; border-radius: 6px;padding:20px;border:1px solid #cdd2da;" /> -->
                            <div v-else class="team-image-table mr-2">
                                <span style="text-transform: uppercase;">{{ createJson.team_name.split(" ")[0].charAt(0) }}{{ createJson.team_name.split(" ").length > 1 ? createJson.team_name.split(" ")[1].charAt(0) : "" }}</span>
                            </div>
                            <!-- <avatar v-else
                                :username="createJson.team_name.trim()"
                                :src="''"
                                :size="100"
                                :rounded="false"
                                style="height: 6em; width: 6em; border-radius: 6px;padding:20px;border:1px solid #cdd2da;"
                                color="#000"
                            ></avatar> -->
                            </span>
                            <custom-upload-picture @CallLoader="CallLoader" @uploadImage="uploadImage" :show_edit_upload="show_edit_upload"></custom-upload-picture>
                        </div>
                        <div>
                            <h6 class="w-180px overflowing-text fw-600" :title="createJson.team_name">{{temp_createJson.team_name}}</h6>
                            <p class="w-460px overflowing-text" :title="createJson.description">{{temp_createJson.description}}</p>
                        </div>
                    </div>
                    <div>
                        <p class="team-mail fw-500">{{createJson.team_email}}</p>
                        <p class="fw-500">Team Owner: {{createJson.owned_by}}</p>
                        <p v-if="activetab=='1'" class="fw-500 mb-0">Created on: {{createJson.created_on}}</p>
                    </div>
                </div>
                <div id="tabs">
                <div class="tabs">
                    <a v-on:click="activetab='1';mode='view'" v-bind:class="[ activetab === '1' ? 'active' : '' ]">Members ({{total}})</a> 
                    <a v-on:click="activetab='2'" v-bind:class="[ activetab === '2' ? 'active' : '' ]" v-if="createJson.created_by_id == loggedInUser.user_id">Settings</a>
                </div>
                </div>
                <!-- Team Information Tab -->
                <div v-if="activetab ==='1'" class="tabcontent">
                    <div class="d-flex justify-content-between pt-2 pb-2 pl-6 pr-6">
                        <div class="d-flex" v-if="createJson.created_by_id == loggedInUser.user_id">
                            <p class="pt-2 fw-500" style="width: 150px;">Members List</p>
                            <multiselect v-if="userPermissions.teams.permitted_actions.create"
                                class="digi-multiselect approval-manager mlti-width filter-multiple"
                                placeholder="Add Members here" track-by="id"
                                label="full_name"
                                v-model="members"
                                :options="members_options"
                                @select="memberSelected"
                                :multiple="true" :searchable="true" :internal-search="true"
                                :clear-on-select="true" :close-on-select="true" :options-limit="400"
                                :max-height="200" :show-no-results="true" :hide-selected="false"
                                :blockKeys="['Delete']" :loading="members_loading" @search-change="getMembersDataList"
                                @open="getMembersDataList"
                                :limit="1" :limit-text="limitMemberTo"
                            >
                                <template slot="tag" slot-scope="{ option }">
                                    <span class="custom__tag">
                                    <span class="filterSelectedName add-members-team">{{ option.full_name }}</span>
                                        <span class="custom__remove pointer" @click="removeMemberTo(option)">
                                        <i class="icon icon-close fs-16 text-white"></i>
                                        </span>
                                    </span>
                                </template>
                                <template slot="afterList">
                                    <div v-observe-visibility="reachedEndOfMembers" />
                                </template>
                                <template slot="noResult">
                                    <div class="text-secondary text-center fw-600">No Results Found</div>
                                </template>
                            </multiselect>
                        </div>
                        <div class="d-flex" style="width: 400px;">
                            <i class="icon icon-magnify icondefault" style="border-radius: 20px 0px 0px 20px; padding: 6px 16px; height: 2.7em;"></i>
                            <input class="w-100 placeholder-text" type="text" v-model="search_members_key" placeholder="Search by Team Member" style="border-radius: 0px 20px 20px 0px; padding-left: 10px; height: 2.9em;" v-debounce:500ms="SearchTeamMembers" debounce-events="input">
                        </div>
                    </div>
                    <div class="pl-6 pr-6">
                        <table class="team-list-table w-100 table-responsive table">
                            <thead>
                                <tr>
                                    <th class="w-1" v-if="createJson.created_by_id == loggedInUser.user_id">
                                        <!-- <label class="custom-control custom-checkbox digi-checkbox" style="width: 10px !important;padding-right: 0px !important;min-width: 10px;">
                                            <input type="checkbox" class="custom-control-input" @change="selectALL()" :checked="this.selected_members_id.length == this.members_list.length && this.selected_members_id.length"/>
                                            <span class="custom-control-indicator" style="color: #fff !important; font-size: 20px; top: -10px !important;"></span>
                                            <span class="form-check-description fw-600"></span>
                                        </label> -->
                                    </th>
                                    <th class="w-1">Team Member</th>
                                    <th class="w-1">Email ID</th>
                                    <th class="w-1">Role</th>
                                    <th class="w-1">Type</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr class="w-100" v-if="callMembersListProgress" style="height: 90px;">
                                    <td colspan="15">
                                        <div class="d-flex align-items-center justify-content-center w-100">
                                            <half-circle-spinner :animation-duration="1000" :size="40" color="#00448b" style="margin: 0 auto;" />
                                        </div>
                                    </td>
                                </tr>
                                <tr v-else-if="!callMembersListProgress && members_list == 0" class="text-center font-weight-bold" style="height: 90px;">
                                    <td colspan="15">No Data Found</td>
                                </tr>
                                <tr v-else v-for="(member, m_index) in members_list" :key="m_index">
                                    <td class="w-1" v-if="createJson.created_by_id == loggedInUser.user_id">
                                        <label class="custom-control custom-checkbox digi-checkbox" style="width: 10px !important;padding-right: 0px !important;min-width: 10px;">
                                            <input type="checkbox" class="custom-control-input" @change="selectOne(member.id)" :checked="selected_members_id.includes(member.id)"/>
                                            <span class="custom-control-indicator" style="font-size: 20px; top: -10px !important;"></span>
                                            <span class="form-check-description fw-600"></span>
                                        </label>
                                    </td>
                                    <td class="text-capitalize">{{member.name}}</td>
                                    <td>{{member.email_id}}</td>
                                    <td class="text-capitalize">
                                        <span v-if="createJson.created_by_id != loggedInUser.user_id">{{member.role}}</span>
                                        <el-dropdown v-else trigger="click" class="type-select">
                                            <span class="el-dropdown-link d-flex justify-content-between w-100">
                                                {{member.role}} <img src="https://cdn.digicollect.com/cdn/dc_crm_fe/static/images/images/down-arrow-grey-full.svg" style="margin-right: 4px;margin-left: 18px;margin-top: -4px;width: 12px !important;">
                                            </span>
                                            <el-dropdown-menu slot="dropdown" v-if="member.role == 'owner'">
                                                <el-dropdown-item>
                                                    <a href="javascript:;" class="decoration-none" :style="createJson.created_by_id != loggedInUser.user_id ? 'color:#ababab' : ''"  :disabled="createJson.created_by_id != loggedInUser.user_id" @click="ChangeRole('Member', m_index)">Member</a>
                                                </el-dropdown-item>
                                                <el-dropdown-item>
                                                    <a href="javascript:;" style="color:#ababab !important" class="decoration-none" disabled>Owner</a>
                                                </el-dropdown-item>
                                            </el-dropdown-menu>
                                            <el-dropdown-menu slot="dropdown" v-else-if="member.role == 'member'">
                                                <el-dropdown-item>
                                                    <a href="javascript:;" class="decoration-none" style="color:#ababab !important" disabled>Member</a>
                                                </el-dropdown-item>
                                                <el-dropdown-item>
                                                    <a href="javascript:;" class="decoration-none" :style="createJson.created_by_id != loggedInUser.user_id ? 'color:#ababab' : ''"  :disabled="createJson.created_by_id != loggedInUser.user_id" @click="ChangeRole('Make Owner', m_index)">Make Owner</a>
                                                </el-dropdown-item>
                                            </el-dropdown-menu>
                                        </el-dropdown>
                                    </td>
                                    <td class="text-capitalize">{{member.type}}</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                    <div v-if="!callMembersListProgress && members_list != 0" class="d-flex justify-content-end align-items-center py-2 px-6" style="border-bottom-left-radius: 5px; border-bottom-right-radius: 5px">
                        <multiselect class="diginew-multiselect list-view-number-dropdown no-default-icon down-arrow"
                            :options="pageLimit" :close-on-select="true" v-model.number="limit"
                            :max-height="210" :allow-empty="false" :searchable="false"
                            open-direction="top" :show-labels="false" placeholder=""
                            style="width: 4.2em !important;padding-right: 0px!important;">
                        </multiselect>
                        <span class="page-info pr-6 pl-1 fw-500 text-dark font-size-small">Per page</span>
                        <button @click="firstPage()" class="mt-1 pagination-list" :class="skip == 0 ? 'not-allowed' : 'pointer'" :disabled="skip == 0">
                            <el-tooltip class="item" effect="dark" content="First Page" placement="top">
                                <i class="icon-chevron-double-left"></i>
                            </el-tooltip>
                        </button>
                        <button @click="previousPage()" class="pagination-list mt-1 ml-2" :class="skip == 0 ? 'not-allowed' : 'pointer'" :disabled="skip == 0">
                            <el-tooltip class="item" effect="dark" content="Previous Page" placement="top">
                                <i class="icon icon-chevron-left"></i>
                            </el-tooltip>
                        </button>
                        <span class="px-2 fw-500 fs-14 mt-1 font-size-small">Showing {{getSkipCount}} - {{total>skip+limit?skip+limit:total}} of {{total}}</span>
                        <button @click="nextPage()" class="pagination-list mt-1 mr-2" :class="skip_temp >= total ? 'not-allowed' : 'pointer'" :disabled="skip_temp >= total">
                            <el-tooltip class="item" effect="dark" content="Next Page" placement="top">
                                <i class="icon icon-chevron-right"></i>
                            </el-tooltip>
                        </button>
                        <button @click="lastPage()" class="mt-1 pagination-list" :class="temp_total+10 >= total ? 'not-allowed' : 'pointer'" :disabled="temp_total+10 >= total">
                            <el-tooltip class="item" effect="dark" content="Last Page" placement="top">
                                <i class="icon-chevron-double-right"></i>
                            </el-tooltip>
                        </button>
                    </div>
                </div>
                <!-- Settings Tab -->
                <div v-if="activetab ==='2'" class="tabcontent bg-white">
                    <div class="pt-6 pl-6 pr-6 pb-10">
                        <div class="row">
                            <div class="col-lg-4 col-md-4 col-sm-12">
                                <div class="w-100 position-relative">
                                    <span class="input-label">Team Name</span>
                                    <div class="d-flex align-content-center mt-2">
                                        <input type="text" name="team_name" :disabled="mode == 'view'" :class="mode == 'edit' ? 'field-enabled' : 'not-allowed'" class="input-field input-width" maxlength="100" v-model="createJson.team_name" placeholder="Team Name" />
                                        <span class="input-field-length float-right" style="position: absolute;bottom:-20px;right:0px">{{ createJson.team_name.length }}/100</span>
                                    </div>
                                    <!-- <div class="text-right mt-1">
                                        <span class="input-field-length float-right">{{ createJson.team_name.length }}/100</span>
                                    </div> -->
                                </div>
                                <div class="row">
                                    <div class="col-lg-12 col-md-12 col-sm-12 mt-6 position-relative">
                                        <span class="input-label text-secondary whiteSpace fs-14 vselectLabel fw-600">
                                            Description
                                        </span>
                                        <div class="d-flex align-items-center">
                                            <textarea-autosize class="digi-textarea white-background bordered" maxlength="500" :class="mode == 'edit' ? 'field-enabled' : 'not-allowed'" :disabled="mode == 'view'" placeholder="Add Description" v-model="createJson.description" style="height: 8em; overflow: auto;" />
                                            <span class="input-field-length float-right" style="position: absolute;bottom:-20px;right:15px">{{ createJson.description.length }}/500</span>
                                        </div>
                                        <!-- <div class="text-right mt-1">
                                            <span class="input-field-length float-right">{{ createJson.description.length }}/100</span>
                                        </div> -->
                                    </div>
                                </div>
                            </div>
                            <div class="col-lg-4 col-md-4 col-sm-12">
                                <div class="w-100">
                                    <span class="input-label">Created On</span>
                                    <div class="d-flex align-content-center mt-2">
                                        <input type="text" name="created_on" disabled class="input-field input-width not-allowed" v-model="createJson.created_on" placeholder="Created Date" />
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col-lg-12 col-md-12 col-sm-12 mt-6">
                                        <div class="w-100">
                                            <span class="input-label">Team Email</span>
                                            <div class="d-flex align-content-center mt-2">
                                                <input type="text" name="team_email" disabled class="input-field input-width not-allowed" v-model="createJson.team_email" placeholder="Team Name" />
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-lg-12 col-md-12 col-sm-12 mt-6">
                                        <div class="w-100">
                                            <span class="input-label">Owned By</span>
                                            <div class="d-flex align-content-center mt-2">
                                                <input type="text" name="owned_by" disabled class="input-field input-width not-allowed" v-model="createJson.owned_by" placeholder="Created Date" />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="col-lg-4 col-md-4 col-sm-12">
                                <div class="role-div">
                                    <p class="fw-500 fs-14">Role Permissions</p>
                                    <ul class="pl-4">
                                        <li>
                                            <span class="fw-500">Owner :</span> Owner creates/deletes a Team.
                                        </li>
                                        <li class="mt-4">
                                            <span class="fw-500">Members :</span> Members : Team Members can view the list of members
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="d-flex flex-wrap align-items-center justify-content-center mb-8" v-if="mode == 'view' && createJson.created_by_id == loggedInUser.user_id">
                        <button class="btn new-cancel-button" style="border: 2px solid !important;width: 160px;" @click="LeaveOwnership">Leave Team</button>
                    </div>
                    <div class="d-flex flex-wrap align-items-center justify-content-center mb-8 mt-10" v-if="disableSaveButtonAndDisplayLoader == false && mode == 'edit' && createJson.created_by_id == loggedInUser.user_id">
                        <button class="btn new-cancel-button" @click="changeMode('view')">Cancel</button>
                        <button class="btn new-save-button ml-5" @click="EditTeamDetails" :disabled="fields_not_changed">Save</button>
                    </div>
                    <div class="d-flex flex-wrap align-items-center justify-content-center mb-8 mt-10" v-else-if="disableSaveButtonAndDisplayLoader == true && mode == 'edit' && createJson.created_by_id == loggedInUser.user_id">
                        <button class="btn new-cancel-button" disabled style="border: none !important;">Cancel</button>
                        <button class="btn new-save-button ml-5" disabled style="position: relative;">Save
                            <hollow-dots-spinner style="position: absolute;margin: 0;top: 22px;display: flex;justify-content: center;width: 100% !important;" :animation-duration="1200" :dot-size="10" :dots-num="3" :color="'#00448b'" />
                        </button>
                    </div>
                </div>
            </div>
        </div>
        <pass-ownership v-if="showPassOwnership" modal_name="pass_ownership" @passOwnership="passOwnership" @hidePassOwnership="hidePassOwnership"></pass-ownership>
        <pass-the-baton :from="from" :has_owner="has_owner" @DeleteOwner="DeleteOwner" :members_list="members_list" @changeOwner="changeOwner" v-if="passbatonmodal" modal_name="pass_baton" @HidePassBatorModal="HidePassBatorModal"></pass-the-baton>
        <add-member v-if="addMemberShow" :selected_team_name="createJson.team_name" :selected_members="selected_members" modal_name="addMember" @loadMembers="loadMembers" @hideAddMember="hideAddMember"></add-member>
        <delete-members v-if="deleteMemberShow" modal_name="deleteMembers" @hideDeleteMember="hideDeleteMember" @DeleteMembers="DeleteMembers"></delete-members>
        <sweet-modal ref="warning_modal" hide-close-button overlay-theme="dark" icon="warning">{{warning_msg}}
        </sweet-modal>
        <sweet-modal ref="success_modal" hide-close-button overlay-theme="dark" icon="success">{{success_msg}}
        </sweet-modal>
        <owner-change-successful v-if="show_owner_change_success" @hideSuccessOwnerChange="hideSuccessOwnerChange" modal_name="ShowOwnerChangeSuccess"></owner-change-successful>
        <add-members-successful :selected_team_name="createJson.team_name" v-if="showSuccessAddedMember" @hideSuccess="hideSuccess" modal_name="Show-Success-Member"></add-members-successful>
    </div>
</template>
<script>
import { HollowDotsSpinner } from "epic-spinners";
import { HalfCircleSpinner } from "epic-spinners";
import {
        SweetModal
    } from 'sweet-modal-vue';
import OwnerChangeSuccessful from "../alertModals/OwnerChangeSuccessful";
import { EventBus } from '../eventBus/nav-bar-event';
const AddMember = () => import("./AddMemberPopUp.vue");
const DeleteMembers = () => import("./DeleteMembers.vue");
const PassOwnership = () => import("../alertModals/PassOwnership.vue");
const PassTheBaton = () => import("../alertModals/PassTheBaton")
import AddMembersSuccessful from '../alertModals/AddMembersSuccessful';
import CustomUploadPicture from '../CustomUploadPicture'
import myUpload from 'vue-image-crop-upload'
// import Avatar from 'vue-avatar'
import teams from '../mixins/teams'
import { debounce } from 'lodash'
export default {
    mixins: [teams],
    data(){
        return{
            stringified_response: "",
            showSuccessAddedMember: false,
            disableButtonAndDisplayLoader: false,
            disableSaveButtonAndDisplayLoader: false,
            warning_msg:'',
            success_msg: '',
            search_members_key: '',
            disableDeletebtn: true,
            deleteMemberShow: false,
            addMemberShow: false,
            activetab: '1',
            ajaxCallinprogress: false,
            members: [],
            members_options: [],
            pageLimit: [],
            members_count: 0,
            temp_members_options: [],
            members_loading: false,
            members_visible: false,
            members_scrollable: false,
            createJson:{
                team_name: "",
                created_on: "",
                description: "",
                team_email: "",
                owned_by: "",
                logo: null,
                created_by_id: "",
            },
            temp_createJson : {
                team_name: "",
                created_on: "",
                description: "",
                team_email: "",
                owned_by: "",
                logo: null,
                created_by_id: "",
            },
            imgDataUrl: '/static/images/logo.svg', // the datebase64 url of created image,
            mode: 'view',
            from: 'list',
            show_upload: false,
            members_list: [],
            hideOwnership:false,
            showPassOwnership:false,
            passbatonmodal: false,
            show_edit_upload: false,
            selected_members_id: [],
            callMembersListProgress: false,
            temp_total: 0,
            skip: 0,
            limit: 10,
            skip_temp: 0,
            total: 0,
            selected_member: null,
            owner_id: '',
            has_owner: false,
            show_owner_change_success: false,
            team_members_ids: [],
            img_loader: false
        }
    },
    components: {
        AddMember,
        HalfCircleSpinner,
        DeleteMembers,
        PassOwnership,
        OwnerChangeSuccessful,
        PassTheBaton,
        CustomUploadPicture,
        myUpload,
        SweetModal,
        HollowDotsSpinner,
        AddMembersSuccessful,
        // Avatar
    },
    methods: {
        hideSuccess(){
            this.showSuccessAddedMember = false;
        },
        limitMemberTo(count){
            return `+ ${count} more`
        },
        //API call to get team members
        async getMembersDataListDebounce(search_key){
            try{
                let params = {
                    skip: 0,
                    limit: 10,
                    search_key: search_key || "",
                    exclude: this.team_members_ids
                };
                let response = await this.getMembersData(params)
                this.members_options = response.response
                this.members_count = this.temp_members_options.length
            }catch(reason){

            }
        },
        //Lazy loading for members list API
        async reachedEndOfMembers(reached){
            this.members_visible = reached
            if (reached) {
                if (this.members_scrollable == false) {
                    this.members_loading = true
                    let params ={
                        skip: this.members_count,
                        limit: 10,
                        search_key: '',
                        exclude: this.team_members_ids
                    }
                    let response = await this.getMembersData(params)
                    this.temp_members_options = response.response.length;
                    if (response.skip == this.members_count) {
                        if (this.temp_members_options > 0) {
                            let tempFiles = response.response;
                            tempFiles.forEach(el => {
                                this.members_options.push(el);
                            });
                            this.members_count += response.response.length;
                            this.members_loading = false
                        } else {
                            this.members_scrollable = true
                            this.members_loading = false
                        }
                    }
                    this.members_loading = false
                }
            }
        },
        memberSelected(value){
            setTimeout(() => {
                this.saveData();
            }, 1000);
        },
        //API call to add member to a team
        async saveData(){
            let temp_data = []
            this.createJsonData.team_members.forEach((members) =>{
                temp_data.push({
                    "name": members.full_name,
                    "email_id": members.email,
                    "profile_pic": members.profile_pic,
                    "user_id": members.user_id,
                })
            })
            try{
                let params = {
                   "team_id": this.$route.params.id,
                   "members": temp_data
                }
                var response = await this.addMembersToTeam(params)
                if (response.status_id == 1) {
                    // this.success_msg = response.message
                    // this.$refs.success_modal.open();
                    // setTimeout(() => {
                    //     this.members = []
                    //     this.$refs.success_modal.close();
                    // }, 1000);
                    this.showSuccessAddedMember = true
                    setTimeout(() => {
                        this.$modal.show('Show-Success-Member')
                    }, 500);
                    setTimeout(() => {
                        this.hideSuccess();
                        this.members = []
                        this.teamMembersListView()
                    }, 3000);
                } else {
                    this.warning_msg = response.reason
                    this.$refs.warning_modal.open();
                    setTimeout(() => {
                        this.members = []
                        this.$refs.warning_modal.close();
                    }, 3000);
                }
            } catch(error){
                this.warning_msg = error
                this.$refs.warning_modal.open();
                setTimeout(() => {
                    this.members = []
                    this.$refs.warning_modal.close();
                }, 3000);
            }
        },
        //API call to save edited team details
        async EditTeamDetails(){
            try{
                this.disableSaveButtonAndDisplayLoader = true;
                let params = {
                    "name": this.Json_data.team_name,
                    "description": this.Json_data.description,
                    "logo": this.Json_data.logo,
                    "last_modified_by": "",
                    "last_modified_by_name": ""
                }
                let id = this.$route.params.id
                let response = await this.EditTeamDataById(id, params);
                if (response.status_id == 1) {
                    this.success_msg = response.message
                    this.$refs.success_modal.open();
                    setTimeout(() => {
                        this.disableSaveButtonAndDisplayLoader = false;
                        this.$refs.success_modal.close();
                        this.changeMode('view-after-edit');
                    }, 3000);
                } else {
                    this.warning_msg = response.reason
                    setTimeout(() => {
                        this.disableSaveButtonAndDisplayLoader = false;
                        this.$refs.warning_modal.close();
                    }, 3000);
                }
            } catch(error){
                this.warning_msg = error
                setTimeout(() => {
                    this.disableSaveButtonAndDisplayLoader = false;
                    this.$refs.warning_modal.close();
                }, 3000);
            }
        },
        //API call to delete owner from team
        async DeleteOwner(new_owner){
            try{
                let params = {
                    "new_owner_id": new_owner.id,
                    "team_id": this.$route.params.id,
                    "is_owner_delete":true
                }
                let response = await this.OwnerLeavesTeam(params);
                if (response.status_id == 1) {
                    this.success_msg = response.message
                    this.$refs.success_modal.open();
                    setTimeout(() => {
                        this.$refs.success_modal.close();
                        this.deleteMemberShow = false
                        this.has_owner = false
                        this.$router.push({
                            path: '/teams/TeamListView'
                        })
                    }, 3000);
                } else {
                    this.warning_msg = response.reason
                    this.$refs.warning_modal.open();
                    setTimeout(() => {
                        this.$refs.warning_modal.close();
                        this.deleteMemberShow = false
                        this.has_owner = false
                    }, 3000);
                }
            } catch(error){
                this.warning_msg = error.reason
                this.$refs.warning_modal.open();
                setTimeout(() => {
                    this.$refs.warning_modal.close();
                    this.deleteMemberShow = false
                }, 3000);
            }
        },
        //API call to delete team member
        async DeleteMembers(){
            try{
                let params = {
                    "team_id": this.$route.params.id,
                    "ids": this.selected_members_id
                }
                let id = this.$route.params.id
                let response = await this.DeleteTeamMembers(id, params);
                if (response.status_id == 1) {
                    this.success_msg = response.message
                    this.$refs.success_modal.open();
                    setTimeout(() => {
                        this.$refs.success_modal.close();
                        this.deleteMemberShow = false
                        this.selected_members_id = []
                        this.skip = 0;
                        this.teamMembersListView()
                    }, 3000);
                } else {
                    this.warning_msg = response.reason
                    this.$refs.warning_modal.open();
                    setTimeout(() => {
                        this.$refs.warning_modal.close();
                        this.deleteMemberShow = false
                    }, 3000);
                }
            } catch(error){
                this.warning_msg = error.reason
                this.$refs.warning_modal.open();
                setTimeout(() => {
                    this.$refs.warning_modal.close();
                    this.deleteMemberShow = false
                }, 3000);
            }
        },
        //API call to change roles
        async ChangeRoleAPI(){
            try{
                let params = {
                    "team_id": this.$route.params.id,
                    "new_owner_id": ""
                }
                let id = this.$route.params.id
                let response = await this.DeleteTeamMembers(id, params);
                if (response.status_id == 1) {
                    this.success_msg = response.message
                    this.$refs.success_modal.open();
                    setTimeout(() => {
                        this.$refs.success_modal.close();
                    }, 3000);
                } else {
                    this.warning_msg = response.reason
                    setTimeout(() => {
                        this.$refs.warning_modal.close();
                    }, 3000);
                }
            } catch(error){
                this.warning_msg = error.reason
                setTimeout(() => {
                    this.$refs.warning_modal.close();
                }, 3000);
            }
            this.skip = this.skip_temp;
            this.teamMembersListView()
        },
        //Pagination methods
        firstPage(){
            this.temp_total = 0
            this.skip = 0
            this.limit = 10
            this.skip_temp = 0
            // this.all_categories = []
            this.teamMembersListView()
        },
        lastPage(){
            this.skip_temp = 0
            this.skip = 0
            this.temp_total = this.total
            let no_of_pages = Math.ceil(this.total/this.limit)
            this.skip_temp = (no_of_pages * this.limit) - this.limit
            if (this.skip_temp >= this.total) {
                return;
            }
            this.skip = this.skip_temp
            this.teamMembersListView();
        },
        nextPage() {
            this.skip_temp = this.skip + this.limit > this.total ? this.total : this.skip + this.limit;
            this.temp_total = this.skip_temp
            if (this.skip_temp >= this.total) {
                return;
            }
            this.skip = this.skip_temp;
            this.teamMembersListView();
        },
        previousPage() {
            this.temp_total = 0
            this.skip_temp = 0
            if (this.skip == 0) {
                return;
            }
            this.skip = this.skip - this.limit <= 0 ? 0 : this.skip - this.limit;
            this.teamMembersListView();
        },
        //Select all checkbox function
        selectALL(){
            if(this.selected_members_id.length == this.members_list.length && this.selected_members_id.length){
                this.selected_members_id = []
                this.disableDeletebtn = true
            } else {
                this.members_list.forEach(el => {
                    this.selected_members_id.push(el.id)
                });
                this.selected_members_id = this.selected_members_id.filter((item,index) => this.selected_members_id.indexOf(item) === index);
                this.disableDeletebtn = false
            }
        },
        //Single select checkbox function
        selectOne(id) {
            if (this.selected_members_id.includes(id)) {
                this.selected_members_id = this.selected_members_id.filter(x => x != id);
                if(this.selected_members_id == ""){
                    this.disableDeletebtn = true
                }
            } else {
                this.selected_members_id.push(id);
                this.disableDeletebtn = false
            }
        },
        HidePassBatorModal(){
            this.passbatonmodal = false;
            this.selected_members_id = [];
        },
        uploadImage (imgData) {
            this.createJson.logo = imgData
            this.img_loader = false
        },
        changeMode(mode){
            if(mode == 'edit'){
                this.mode = 'edit'
                this.show_edit_upload = true
            } else if(mode == "view-after-edit"){
                this.mode = 'view'
                this.show_edit_upload = false
                this.loadTeamView();
            }
            else {
                this.mode = 'view'
                this.show_edit_upload = false
                this.createJson.team_name = this.temp_createJson.team_name
                this.createJson.created_on = this.temp_createJson.created_on
                this.createJson.description = this.temp_createJson.description
                this.createJson.team_email = this.temp_createJson.team_email
                this.createJson.owned_by = this.temp_createJson.owned_by
                this.createJson.logo = this.temp_createJson.logo
            }
        },
        //API call to change owner
        async changeOwner(new_owner){
            if(this.from == 'list'){
                try{
                    let params = {
                        "team_id": this.$route.params.id,
                        "new_owner_id": new_owner.id
                    }
                    let id = this.$route.params.id
                    let response = await this.ChangeMemberRole(id, params);
                    if (response.status_id == 1) {
                        this.success_msg = response.message
                        this.$refs.success_modal.open();
                        setTimeout(() => {
                            this.$refs.success_modal.close();
                            this.passbatonmodal = false
                            this.loadTeamView();
                            this.teamMembersListView();
                        }, 3000);
                    } else {
                        this.warning_msg = response.reason
                        setTimeout(() => {
                            this.$refs.warning_modal.close();
                        }, 3000);
                    }
                } catch(error){
                    this.warning_msg = error.reason
                    setTimeout(() => {
                        this.$refs.warning_modal.close();
                    }, 3000);
                }
            }
        },
        //API call to pass ownership to other team member
        async passOwnership(){
            try{
                let params = {
                    "team_id": this.$route.params.id,
                    "new_owner_id": this.selected_member.id
                }
                let id = this.$route.params.id
                let response = await this.ChangeMemberRole(id, params);
                if (response.status_id == 1) {
                    // this.success_msg = response.message
                    // this.$refs.success_modal.open();
                    // setTimeout(() => {
                    //     this.$refs.success_modal.close();
                    //     this.showPassOwnership = false
                    //     this.loadTeamView();
                    //     this.teamMembersListView();
                    // }, 3000);
                    this.HidePassBatorModal();
                    this.show_owner_change_success = true
                    setTimeout(() => {
                        this.$modal.show('ShowOwnerChangeSuccess')
                    }, 500);
                } else {
                    this.warning_msg = response.reason
                    setTimeout(() => {
                        this.$refs.warning_modal.close();
                    }, 3000);
                }
            } catch(error){
                this.warning_msg = error.reason
                setTimeout(() => {
                    this.$refs.warning_modal.close();
                }, 3000);
            }
        },
        //Opens popup to change roles
        ChangeRole(role_type, index){
            if(role_type == 'Member'){
                this.from = 'list'
                this.passbatonmodal = true
                setTimeout(() => {
                    this.$modal.show("pass_baton")
                }, 500);
            } else if(role_type == 'Owner'){

            } else if(role_type == 'Make Owner'){
                this.showPassOwnership = true
                this.selected_member = this.members_list[index]
                setTimeout(() => {
                    this.$modal.show('pass_ownership')
                }, 500);
            }
        },
        LeaveOwnership(){
            this.from = 'view'
            this.has_owner = true
            this.passbatonmodal = true
            setTimeout(() => {
                this.$modal.show("pass_baton")
            }, 500);
        },
        hideSuccessOwnerChange(){
            this.loadTeamView()
            this.teamMembersListView()
            this.hidePassOwnership()
            this.HidePassBatorModal()
        },
        hidePassOwnership(){
            this.showPassOwnership = false;
        },
        addMember(){
            this.addMemberShow = true;
            setTimeout(() => {
                this.$modal.show("addMember")
            }, 500);
        },
        hideAddMember(){
            this.addMemberShow = false;
        },
        //Opens delete member popup
        deleteMember(){
            this.disableDeletebtn = true;
            this.disableButtonAndDisplayLoader = true;
            let check_owner = this.selected_members_id.some(x => x == this.owner_id)
            if(check_owner && this.selected_members_id.length < 2){
                this.from = 'view'
                this.has_owner = true
                this.passbatonmodal = true
                setTimeout(() => {
                    this.disableButtonAndDisplayLoader = false;
                    this.$modal.show("pass_baton")
                }, 500);
            }else if(!check_owner){
                this.deleteMemberShow = true;
                this.has_owner = false
                setTimeout(() => {
                    this.disableButtonAndDisplayLoader = false;
                    this.$modal.show("deleteMembers")
                }, 500);
            } else {
                this.warning_msg = 'Owner Cannot Be Deleted Along With Members'
                this.$refs.warning_modal.open();
                setTimeout(() => {
                    this.selected_members_id = [];
                    this.disableButtonAndDisplayLoader = false;
                    this.$refs.warning_modal.close();
                    this.deleteMemberShow = false
                }, 3000);
            }
            this.disableButtonAndDisplayLoader = false;
        },
        hideDeleteMember(){
            this.deleteMemberShow = false;
            this.selected_members_id = [];
        },
        loadMembers(){
            this.teamMembersListView()
        },
        async SearchTeamMembers(){
            this.temp_total = 0
            this.skip = 0
            this.limit = 10
            this.skip_temp = 0
            this.callMembersListProgress = true
            let params = {
                "limit": this.limit == '' || 0 || null || undefined ? 10 : this.limit,
                "skip": this.skip,
                "search_key": this.search_members_key,
                "team_id": this.$route.params.id
            }
            let response = await this.TeamMembersListById(params)
            this.members_list = response.response
            this.total = response.count
            this.callMembersListProgress = false
        },
        //API call to get all team members list data
        async teamMembersListView(){
            this.callMembersListProgress = true
            let params = {
                "limit": this.limit == '' || 0 || null || undefined ? 10 : this.limit,
                "skip": this.skip,
                "search_key": "",
                "team_id": this.$route.params.id
            }
            let response = await this.TeamMembersListById(params)
            this.members_list = response.response
            this.team_members_ids = response.user_ids
            this.selected_members = this.team_members_ids
            this.members_list.forEach((el) => {
                if(el.role == 'owner'){
                    this.owner_id = el.id
                }
            })
            this.total = response.count
            this.callMembersListProgress = false
        },
        async loadTeamView(){
            let response = await this.GetTeamDataById(this.$route.params.id);
            this.createJson.team_name = response.response.name
            this.createJson.created_on = response.response.created_on
            this.createJson.description = response.response.description
            this.createJson.team_email = response.response.email_id
            this.createJson.owned_by = response.response.owner
            this.createJson.logo = response.response.logo
            this.createJson.created_by_id = response.response.created_by_id
            this.temp_createJson.team_name = response.response.name
            this.temp_createJson.created_on = response.response.created_on
            this.temp_createJson.description = response.response.description
            this.temp_createJson.team_email = response.response.email_id
            this.temp_createJson.owned_by = response.response.owner
            this.temp_createJson.logo = response.response.logo
            this.temp_createJson.created_by_id = response.response.created_by_id
            return this.stringified_response = JSON.stringify(this.Json_data)
        },
        CallLoader(){
            this.img_loader = true
        }
    },
    mounted(){
        this.loadTeamView()
        this.teamMembersListView()
        for (let i = 10; i <= 50; i+=10) {
            this.pageLimit.push(i);
        }
    },
    created(){
        this.getMembersDataList = debounce(this.getMembersDataListDebounce, 500)
    },
    computed:{
        Json_data(){
            return{
                team_name: this.createJson.team_name,
                created_on: this.createJson.created_on,
                description: this.createJson.description,
                team_email: this.createJson.team_email,
                owned_by: this.createJson.owned_by,
                logo: this.createJson.logo,
            }
        },
        loggedInUser() {
            return this.$store.state.loggedInUser;
        },
        userPermissions(){
            return this.$store.getters.userPermissions;
        },
        createJsonData(){
            return {
                team_members: this.members,
            }
        },
        getSkipCount(){
            if(this.total == 0) {
                return 0
            } else {
                let skip_count = this.skip>this.total?this.total:this.skip+1;
                return skip_count;
            }
        },
        fields_not_changed(){
            return this.stringified_response == JSON.stringify(this.Json_data)
        }
    }
}
</script>
<style scoped>
    .btn-icon{
        width: 36px;
        margin-left: -12px;
    }
    .btn-new-save {
        color: #fff;
        background-color: #1A9347;
    }
    .team-icon{
        background-color: #36B37E;
        width: 65px;
        height: 60px;
        color: #fff;
        font-size: 30px;
        font-weight: 600;
        text-align: center;
        padding-top: 8px;
        border-radius: 6px;
        margin-right: 14px;
    }
    .team-member-card{
        background-color: #fff;
        padding: 24px 24px 14px 24px;
        border-radius: 8px;
    }
    .team-mail{
        background-color: #E5F0FC;
        padding: 6px;
        padding-left:8px;
        color: #206AD3;
        border-radius: 6px;
        margin-left: -8px;
    }
    .tabs {
        overflow: hidden;
        margin-bottom: 10px; /* hide bottom border */
        margin-left: 10px;
    }
    .tabs a{
        float: left;
        cursor: pointer;
        padding: 0px 10px;
        border-right: none;
        font-weight: 600;
        color: #AFAFAF;
    }
    .tabs a:hover {
        color: #226BD3;
    }
    .tabs a.active {
        background-color: #fff;
        color: #226BD3;
        border-bottom: 2px solid #226BD3;
        cursor: default;
    }
    .team-list-table{
        max-height: 430px;
    }
    .team-list-table thead tr th {
        background: #00448b;
        color: #fff;
        padding: 10px 30px;
        font-size: 14px;
        font-weight: 600;
        white-space: nowrap;
    }

    .team-list-table thead tr th:first-child {
        border-top-left-radius: 5px;
        border-bottom-left-radius: 5px;
    }

    .team-list-table thead tr th:last-child {
        border-top-right-radius: 5px;
        border-bottom-right-radius: 5px;
    }

    .team-list-table tbody tr td {
        background: transparent;
        padding: 13px 30px;
        font-size: 14px;
        font-weight: 500;
        white-space: nowrap;
    }

    .team-list-table tbody tr td span img {
        width: 30px !important;
        height: 30px !important;
        margin-left: -10px;
    }
    .tabcontent{
        background-color: #E8EFFF;
        border-radius: 6px;
    }
    .container {
        width: 100%;
        padding-right: 15px;
        padding-left: 15px;
        margin-right: 0px;
        margin-left: 0px;
        max-width: 1250px !important;
    }
    .overflow-table-col-text {
        width: 250px;
        overflow: hidden;
        text-overflow: ellipsis;
    }
    .cell-width{
        max-width: 200px;
    }
    .type-select {
        background:transparent;
        display: flex;
        align-items: center;
        justify-content: center;
        color: #000;
        width: fit-content;
    }
    .btn-new-edit {
        border: 2px solid #005dae;
        line-height: 30px;
        border-radius: 5px;
        background-color: #005dae;
    }
    .input-label {
        font-weight: 600;
        line-height: 1.5;
        letter-spacing: 0.39px;
        text-align: left;
        color: #005dae;
        padding: 0 0 6px 12px;
        font-size: 14px;
    }
    .input-field {
        border-radius: 6px !important;
        background-color: #F5F5F5;
        padding: 8px 10px;
        width: 100% !important;
        height: 40px;
        color: #000;
        font-size: 14px!important;
        font-weight: 600;
    }
    .input-width {
        border-radius: 5px !important;
        background-color: #F5F5F5;
        padding: 8px 10px;
        width: 100% !important;
        height: 40px !important;
    }
    .role-div{
        background-color: #F5F5F5;
        margin-top: 26px;
        height: 230px;
        border-radius: 8px;
        padding: 30px;
        line-height: 24px;
    }
    .digi-textarea{
        height: 130px !important;
        border: none !important;
        border-radius: 5px;
        background-color: #F5F5F5 !important;
    }
    .btn-new-cancel {
        color: #005dae;
        background-color: #fff;
        border-radius: 5px;
        text-transform: none;
        font-weight: 500;
        border: 2px solid #005dae;
        line-height: 30px;
        box-shadow: none;
        padding-left: 30px;
        padding-right: 30px;
    }
    .btn-new-outline-danger{
        color: #e82828;
        background-color: transparent;
        border-radius: 5px;
        text-transform: none;
        font-weight: 500;
        border: 2px solid #e82828;
        line-height: 30px;
        box-shadow: none;
        padding-left: 30px;
        padding-right: 30px;
    }

    .btn-new-success{
        color: #fff;
        background-color: #1a9347;
        border-radius: 5px;
        text-transform: none;
        font-weight: 500;
        border: 2px solid #1a9347;
        line-height: 30px;
        box-shadow: none;
        padding-left: 30px;
        padding-right: 30px;
    }

    .field-enabled{
        border: solid 1px #676767 !important;
        background: transparent !important;
    }
    .decoration-none{
        text-decoration: none;
    }

    .team-image-table {
        color: #fff;
        font-weight: 500;
        font-size: 16px;
        background: #36b37e;
        border-radius: 5px;
        width: 50px;
        height: 50px;
        display: flex;
        align-items: center;
        justify-content: center;
    }
    .description-text{
        word-break: break-all;
        max-width: 1000px;
    }
    .position-relative{
        position: relative !important;
    }
    .w-460px{
        width:460px !important;
    }
    .w-180px{
        width:180px !important;
    }
    .overflowing-text{
        text-overflow: ellipsis !important;
        overflow: hidden !important;
        white-space: nowrap;
    }
    .add-members-team{
        max-width: fit-content !important;
    }
    .font-size-small{
        height: 2.4rem;
        line-height: 2.4rem;
        color: #4e5764;
        font-size: 14px;
    }
    @media only screen and (max-width: 525px) {
        .font-size-small{
            font-size: 12px !important;
            padding-left: 0px !important;
        }
    }
    @media screen and (max-width:820px){
        .w-460px{
            width:auto !important;
            white-space: normal !important;
        }
    }
    @media only screen and (max-width: 577px) {
        .margin-mx-577{
            margin-bottom: 10px !important;
        }
        .mar-top-zero{
            margin-top: 0px !important;
        }
    }
</style>


// WEBPACK FOOTER //
// src/components/Teams/ViewTeam.vue